import { render, staticRenderFns } from "./Port.vue?vue&type=template&id=1bd250fe&scoped=true"
import script from "./Port.vue?vue&type=script&lang=js"
export * from "./Port.vue?vue&type=script&lang=js"
import style0 from "./Port.vue?vue&type=style&index=0&id=1bd250fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd250fe",
  null
  
)

export default component.exports